"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const rednessskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-rednessskin` : '') + (description ? ` desc-rednessskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-rednessskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-rednessskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.28 18.22a.75.75 0 0 1 .5 1.42c-.34.11-.71.2-1.1.26a8.87 8.87 0 0 1-3.6-.26.75.75 0 0 1 .5-1.42c.21.08.5.14.82.19a7.36 7.36 0 0 0 2.06 0l.23-.04c.23-.04.43-.1.6-.15Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.11 14.42c.96-.17 1.84.17 2.25 1.05a1.7 1.7 0 0 1 0 1.65c-.33.68-.89 1.1-1.65 1.05-.75-.05-1.07-.59-1.5-1.2-.36-.52-.75-.89-.6-1.5.17-.7.8-.93 1.5-1.05Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.77 15.4c.41-.87 1.3-1.2 2.25-1.04.7.12 1.33.35 1.5 1.05.15.61-.24.98-.6 1.5-.43.61-.75 1.15-1.5 1.2-.76.05-1.31-.37-1.65-1.05a1.73 1.73 0 0 1 0-1.65Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.17 15.7a.75.75 0 0 1 .68 1.33l-.07.04h-.01l-.03.01-.08.04c-.06.03-.15.07-.26.1-.19.08-.5.18-.84.18a2.54 2.54 0 0 1-1.1-.28l-.07-.04h-.03v-.01a.75.75 0 0 1 .67-1.34l.05.02.16.07c.15.05.27.08.32.08.06 0 .18-.03.33-.08l.16-.07.04-.02h.01l.07-.03Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.66 12.15a.75.75 0 0 1 .83 1.25l-.07.04-.01.01a2.46 2.46 0 0 1-.16.09l-.42.2c-.31.13-.8.3-1.29.3a3.6 3.6 0 0 1-1.29-.3 5.9 5.9 0 0 1-.57-.29h-.02a.75.75 0 0 1 .76-1.3l.03.01c.01.02.04.03.08.05l.31.15c.27.11.53.19.7.19a2 2 0 0 0 .7-.2 4.42 4.42 0 0 0 .4-.19h.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.66 12.15a.75.75 0 0 1 .83 1.25l-.07.04-.01.01a2.46 2.46 0 0 1-.16.09l-.42.2c-.31.13-.8.3-1.29.3a3.6 3.6 0 0 1-1.29-.3 5.9 5.9 0 0 1-.57-.29h-.02a.75.75 0 0 1 .76-1.3l.03.01c.01.02.04.03.08.05l.31.15c.27.11.53.19.7.19a2 2 0 0 0 .7-.2 4.42 4.42 0 0 0 .4-.19h.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9.56a7.82 7.82 0 0 1 4.73-.32c.65.2 1.23.51 1.67.96a8.2 8.2 0 0 1 6.5 2.78c1.56 1.85 2.23 4.46 1.8 7.4-.35 2.51-1.03 4.99-2.74 6.85a7.86 7.86 0 0 1-1.78 2.96 7.8 7.8 0 0 1-8.31 1.92l-.37-.15a7.81 7.81 0 0 1-3.97-3.78 10.84 10.84 0 0 1-4.08-8.37v-.53c.09-5.4 3.28-8.54 6.54-9.72Zm4.4 5.77-.28.02a6.32 6.32 0 0 0-5.87 6.32v2.86a6.34 6.34 0 0 0 6.3 6.56 6.3 6.3 0 0 0 2.47-.5l.29-.14a6.31 6.31 0 0 0 3.55-5.92v-.04l.05-2.82a6.35 6.35 0 0 0-6.33-6.34h-.18Zm-.1-4.65a6.34 6.34 0 0 0-3.8.29c-2.73 1-5.48 3.62-5.55 8.35v.47a9.35 9.35 0 0 0 1.8 5.44 7.86 7.86 0 0 1 0-.72v-2.84a7.85 7.85 0 0 1 7.55-7.83 1.6 1.6 0 0 0 1.42-1.6 1.38 1.38 0 0 0-.28-.87c-.23-.3-.6-.53-1.13-.69Zm2.88 1.05a3.15 3.15 0 0 1-.58 2.37 7.83 7.83 0 0 1 5.8 7.57v.01l-.03 2.02c.41-1.07.67-2.26.85-3.54.38-2.59-.23-4.75-1.47-6.22a6.5 6.5 0 0 0-4.57-2.21Z",
    fill: "#232323"
  }));
};
var _default = exports.default = rednessskin;